// export const ERP_URL = 'http://localhost:8001/';
export const ERP_URL = window.ERP_URL
// export const ERP_URL = 'https://erp-api-dev.simplus.space'
// export const ERP_URL = 'https://erp-api.simplus.vn'
